import React, { useEffect, useState } from 'react'
import { NavLink } from 'react-router-dom'
import { Slider } from '@material-ui/core';
// CSS
import '../assets/css/product-filters.css'

export default function ProductFilters(props) {
  const [categoryFilterShow, setCategoryFilterShow] = useState(true);
  const [priceFilterShow, setPriceFilterShow] = useState(true);
  const [sizeFilterShow, setSizeFilterShow] = useState(true);
  const [colorFilterShow, setColorFilterShow] = useState(true);
  const [priceFilterVal, setPriceFilterVal] = useState([0, 10000]);

  if(priceFilterVal[1] - priceFilterVal[0] === 1) {
    priceFilterVal[1] = 10000;
  }

  useEffect(() => {
    var categoryDropdownData = {};

    document.querySelectorAll('.category_title').forEach((categoryShowBtn, i) => {
      categoryDropdownData['cateogry_' + i] = false;
      categoryShowBtn.addEventListener('click', () => {
        categoryDropdownData['cateogry_' + i] = !categoryDropdownData['cateogry_' + i];
        if(categoryDropdownData['cateogry_' + i]) {
          categoryShowBtn.classList.add('active');
        } else { 
          categoryShowBtn.classList.remove('active');
        }
      })
    })
  })

  

  function resetFilters(){
    setPriceFilterVal([0, 10000]);
  }
  
  return (
    <div className='product_filters'>
      <div className='product_filter categories'>
        <div className='header'>
          <div className='title'>Categories</div>
          <span className={categoryFilterShow? 'fas fa-minus' : 'fas fa-plus'} onClick={() => {setCategoryFilterShow(!categoryFilterShow)}}></span>
        </div>
        <div className={categoryFilterShow? 'content' : 'content hide'}>
          <ul className='category_list'>
            <li>
              <div className='category_title'><NavLink to='/category/cloths'>Cloths (05)</NavLink> <span className='fas fa-caret-down'></span></div>
              <ul className='sub_category_list'>
                <li><NavLink to='/category/cloths/mens'>Mens</NavLink></li>
                <li><NavLink to='/category/cloths/womens'>Womens</NavLink></li>
              </ul>
            </li>
            
            <li>
              <div className='category_title'><NavLink to='/category/dress'>Dress (05)</NavLink> <span className='fas fa-caret-down'></span></div>
              <ul className='sub_category_list'>
                <li><NavLink to='/category/dress/mens'>Mens</NavLink></li>
                <li><NavLink to='/category/dress/womens'>Womens</NavLink></li>
              </ul>
            </li>
          </ul>
        </div>
      </div>
  
      <div className='product_filter price'>
        <div className='header'>
          <div className='title'>Price</div>
          <span className={priceFilterShow? 'fas fa-minus' : 'fas fa-plus'} onClick={() => {setPriceFilterShow(!priceFilterShow)}}></span>
        </div>
        
        <div className={priceFilterShow? 'content' : 'content hide'}>
          <div className='range'>
            <Slider value={priceFilterVal} min={0} max={10000} onChange={(e, val) => {setPriceFilterVal(val)}} />
          </div>
          <div className='infos'>
            <div className='values'>Price: {props.currency}{priceFilterVal[0]} - {props.currency}{priceFilterVal[1]}</div>
            <button>Filter</button>
          </div>
        </div>
      </div>
  
      <div className='product_filter size'>
        <div className='header'>
          <div className='title'>Size</div>
          <span className={sizeFilterShow? 'fas fa-minus' : 'fas fa-plus'} onClick={() => {setSizeFilterShow(!sizeFilterShow)}}></span>
        </div>
  
        <div className={sizeFilterShow? 'content' : 'content hide'}>
          <div className='size_list'>
            <div className='card'>XL</div>
            <div className='card active'>L</div>
            <div className='card'>M</div>
            <div className='card'>S</div>
            <div className='card'>XS</div>
          </div>
        </div>
      </div>

      <div className='product_filter color'>
        <div className='header'>
          <div className='title'>Color</div>
          <span className={colorFilterShow? 'fas fa-minus' : 'fas fa-plus'} onClick={() => {setColorFilterShow(!colorFilterShow)}}></span>
        </div>
  
        <div className={colorFilterShow? 'content' : 'content hide'}>
          <div className='color_list'>
            <div className='card' style={{background: 'white'}}></div>
            <div className='card active' style={{background: 'red'}}></div>
            <div className='card' style={{background: 'green'}}></div>
            <div className='card' style={{background: 'blue'}}></div>
            <div className='card' style={{background: 'orange'}}></div>
            <div className='card' style={{background: 'purple'}}></div>
            <div className='card' style={{background: 'black'}}></div>
          </div>
        </div>
      </div>
  
      <div className='product_filter reset'>
        <div className='content'>
          <button className='primary_btn' onClick={resetFilters}>Reset Filter</button>
        </div>
      </div>
    </div>
  )
}

export function FiltersNav(props){
  var page = props.page;

  return (
    <div className='filters_nav'>
      <div className='left'>
        <div className='filters_toggle_btn' onClick={() => {props.setProductsFilterShow(true)}}><span className='fas fa-filter'></span> Filters</div>
        <div className='sort'>
          <div className='title'>Sort by:</div>
          <select>
            <option>Relevance</option>
            <option>Price: Low to High</option>
            <option>Price: High to Low</option>
          </select>
        </div>
      </div>
      <div className='right'>
        <div className='show'>
          <div className='title'>Show:</div>
          <select>
            <option>12</option>
            <option>24</option>
            <option>36</option>
          </select>
        </div>
        <div className='view'>
          <span className='fas fa-th' onClick={() => {props.setProductCard(1)}}></span>
          <span className='fas fa-list' onClick={() => {props.setProductCard(2)}}></span>
        </div>
      </div>
    </div>
  )
}
